import { Box, Container, Grid } from '@mui/material';
import { LetterSpacedHeading } from 'components/common';

import OurPrincipleIcon1 from 'assets/images/whypod-icon3.svg';
import OurPrincipleIcon2 from 'assets/images/whypod-icon2.svg';
import OurPrincipleIcon3 from 'assets/images/whypod-icon5.svg';
import OurPrincipleIcon4 from 'assets/images/our-principle-icon4.svg';
import { OurPrinciplesCard, OurPrinciplesCardProps } from './OurPrinciplesCard';

const items: OurPrinciplesCardProps[] = [
  {
    title: 'Excellence',
    content: `We, at POD, are committed to EXCELLENCE. We are always pushing our boundaries and setting higher standards to deliver a world-class experience on India's first fundraising platform.`,
    image: OurPrincipleIcon1,
  },
  {
    title: 'Transparency',
    content: `We pride ourselves on nurturing an open, honest and completely TRANSPARENT mode of operation. We have a system that provides end-to-end visibility of our processes.`,
    image: OurPrincipleIcon2,
  },
  {
    title: 'Democratic',
    content: `We are one hundred per cent dedicated to creating and adopting the highest standards of DEMOCRACY in our modus operandi. All our business processes are inclusive and open to all individuals.`,
    image: OurPrincipleIcon3,
  },
  {
    title: 'Innovation',
    content: `Working on cutting edge technologies is our bread and butter. The features on the POD platform are an industry first, shaped by unparalleled INNOVATION and world-class navigation.`,
    image: OurPrincipleIcon4,
  },
];

const OurPrinciples = () => {
  return (
    <Box
      pt="78px"
      pb="65px"
      sx={{ backgroundColor: 'rgba(218, 255, 243, 0.5)' }}
    >
      <Container>
        <LetterSpacedHeading sx={{ pt: '20px', pb: '40px' }} component="h2">
          OUR PRINCIPLES
        </LetterSpacedHeading>
        <Grid container spacing={3}>
          {items.map((item, i) => (
            <OurPrinciplesCard key={i} {...item} />
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default OurPrinciples;
